<template>
  <el-dialog
    :title="params.title"
    :visible.sync="value.visible"
    width="900px"
    append-to-body
  >
    <FileList v-if="value.visible" :mode="params.mode" :org-id="params.orgId" :max-select="params.maxSelect" :max-size="params.maxSize" :file-type="params.fileType" @selected="onSelected" />
  </el-dialog>

</template>

<script>
import FileList from '@/components/FileList.vue'

export default {
  name: 'DlgChooseFile',
  components: {
    FileList
  },
  props: {
    value: {
      type: Object,
      default: () => ({
        visible: false
      })
    },
    params: {
      type: Object,
      default: () => ({
        title: '选择文件',
        fileType: 'image',
        orgId: '',
        maxSelect: 1,
        maxSize: 100 * 1000 * 1000 * 1000, // 单个文件大小上限
        mode: 'dialog'
      })
    }
  },
  emits: ['ok', 'cancel'],
  data() {
    return {
    }
  },
  computed: {
  },
  watch: {
  },
  created() {
  },
  mounted() {
    console.log(this.value)
  },

  methods: {
    onCancel() {
      console.log('cancel')
      this.value.visible = false
      this.$emit('cancel')
    },
    async onSelected(fileList) {
      this.value.visible = false
      this.$emit('ok', fileList)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.el-dialog__body {
  background: #f5f5f5;
}
</style>
